var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{ref:"submit_button",class:_vm.btnClass,attrs:{"variant":"primary","type":"submit"},on:{"click":_vm.disableButtonUntilResolving}},[_vm._v(" "+_vm._s(_vm.submitText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }